import { MonthlyClosing } from 'common/models'
import moment from 'moment'

export const shouldShowEmptyDepreciationTable = (
  selectedDate: string,
  startUsage: string,
  transitionAt: string,
  startDepreciationDate: string,
  currentMonthlyClosing: MonthlyClosing
) => {
  const termMonthEndDate = currentMonthlyClosing?.to_term_month?.end_date
  let dateForCompare = startUsage
  if (!startUsage || (transitionAt && moment(transitionAt).isAfter(moment(dateForCompare)))) {
    dateForCompare = transitionAt
  }
  if (!startUsage || (startDepreciationDate && moment(startDepreciationDate).isAfter(moment(dateForCompare)))) {
    dateForCompare = startDepreciationDate
  }

  return (
    !dateForCompare ||
    moment(termMonthEndDate).isBefore(moment(dateForCompare)) ||
    moment(selectedDate).isBefore(dateForCompare)
  )
}
